
import type { InferRegleRules, RegleCustomFieldStatus } from '@regle/core';
import ReglePlugin from "../src/runtime/setupFile/regle-plugin";
export const { inferRules, useRegle, useCollectScope, useScopedRegle } = ReglePlugin;

export type RegleFieldStatus<
  TState extends unknown = any,
  TRules extends keyof InferRegleRules<typeof useRegle> = keyof InferRegleRules<typeof useRegle>,
> = RegleCustomFieldStatus<typeof useRegle, TState, TRules>;

